export default "__VITE_ASSET__CVxgNOme__"